module.exports = __webpack_public_path__ + "static/img/user.24a96b16.png";